export const DEVELOPMENT_ROUTINES = [
    {
        description:
            "External knowledge-sharing sessions, like “3D in Figma: Design, Documentation, Development” or internal team gatherings to dive deep into someone's area of expertise, share insights from workshops and training, or simply geek out over a fascinating topic.",
        id: 1,
        title: 'Meetups',
    },
    {
        description: `Three-day events, sometimes with a specific topic, e.g. "The AI Improvement". While it's held remotely, we encourage people to come to the office at this time to revive the brainstorming sessions.`,
        id: 2,
        title: 'Hackathons',
    },
    {
        description:
            'Biweekly meetings, keeping us in the loop on the latest developments in our tech.',
        id: 3,
        title: 'Tech AllHands',
    },
    {
        description:
            "Workshops dependent on each team's needs. Sometimes facilitated by our team members (we have our own public speaking trainer on board!) or external parties e.g., Pantone workshops for the Design team.",
        id: 4,
        title: 'Team workshops',
    },
    {
        description:
            'Six days off per year per employee to step back from the regular tasks and dive into something new or improve already acquired skills that can be later shared with the community and team members.',
        id: 5,
        title: 'Personal Development Days',
    },
    {
        description:
            'Quarterly sessions that connect mentors and mentees for about four focused meetings per cycle. Through ongoing support, participants gain practical guidance and enhanced abilities.',
        id: 6,
        title: 'Mentoring',
    },
];
